import { type LocaleDefinition } from '@solinkcorp/locale';
import {
  AI_INSPECTION_END_TYPE,
  type AiInspectionEndType,
} from 'components/SpotCheckPanel/hooks/useSpotCheckForm';
import moment from 'moment-timezone';
import LocaleUtil from 'utils/LocaleUtil';

export function getFormattedScheduledSummary(
  startTime: number,
  endTime: number,
  reocurringCount: number,
  endType: AiInspectionEndType,
  timezoneId: string,
  locale: LocaleDefinition,
) {
  const formattedStartTime = moment(startTime).tz(timezoneId).format('LT');
  const formattedStartDate = moment(startTime).tz(timezoneId).isSame(moment(), 'day')
    ? locale.date.today
    : LocaleUtil.getLocalizedStr({
        string: locale.scheduledAIChat.onDate,
        replacements: {
          date: moment(startTime).tz(timezoneId).format('MMM D, YYYY'),
        },
      });

  const expiresMap = {
    [AI_INSPECTION_END_TYPE.date]: LocaleUtil.getLocalizedStr({
      string: locale.scheduledAIChat.expiresOn,
      replacements: {
        date: moment(endTime).tz(timezoneId).format('MMM D, YYYY'),
      },
    }),
    [AI_INSPECTION_END_TYPE.occurrence]: LocaleUtil.getLocalizedStr({
      string: locale.scheduledAIChat.expiresAfter,
      replacements: {
        count: reocurringCount,
      },
    }),
    [AI_INSPECTION_END_TYPE.never]: locale.scheduledAIChat.neverExpires,
  };

  return LocaleUtil.getLocalizedStr({
    string: locale.scheduledAIChat.spotCheckScheduleSummary,
    replacements: {
      start: formattedStartDate,
      time: formattedStartTime,
      expiry: expiresMap[endType],
    },
  });
}
